import {ProductDetails} from "@app/core/product/domain/dtos/product-details";
import {Observable} from "rxjs";


export abstract class ProductComparisonLocal {

    public abstract addProduct(productDetails:ProductDetails): void;
    public abstract getProducts(): Observable<ProductDetails[]>
    public abstract deleteProduct(productCode:string): void;

}